export enum OrbitDocumentTypeEnum {
    CC = 'CC',
    CE = 'CE',
    NIT = 'NIT',
    TI = 'TI',
    PP = 'PP',
    PEP = 'PEP',
    RC = 'RC',
}

export enum OrbitPersonTypeEnum {
    Natural = 'NATURAL',
    Juridica = 'JURIDICA',
}

export enum OrbitGenderEnum {
    NoBinario = 'NO_BINARIO',
    Masculino = 'MASCULINO',
    Femenino = 'FEMENINO',
    NoAplica = 'NA',
}
